// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import cn from 'classnames';
import React, {useEffect, useRef, useState, Fragment, useContext} from 'react';
import {Button} from '../lib/button';
import {use_screen} from '../lib/screen_util';
import {Spinner} from '../lib/spinner';
import {Currency_select} from './currency_select';
import styles from './payment_form.module.less';
import {Plans_select} from './plans_select';
import plus_ui from '/www/hola/pub/plus_ui.js';
import {Settings_context} from '../settings_ctx';
// @ts-ignore
import {get_per} from '../../../../svc/account/pub/membership.js';
import {i_plan_extended} from './plus_types';

interface i_payment_form_props {
    opt: any;
    visible: boolean;
    cls?: string;
    limited_height?: number;
    with_trial?: boolean;
    on_click?: (ev:any)=>void;
}

export const Payment_form = (props:i_payment_form_props)=>{
    const {theme} = useContext(Settings_context);
    const root_ref = useRef();
    const content_ref = useRef();
    const [has_scroll, set_has_scroll] = useState(false);
    const {width, height} = use_screen();
    const [refresh, set_refresh] = useState(0);
    const [method_chosen, set_method_chosen] = useState(false);
    const [view_method, set_view_method] = useState('cc');
    const [premium_warning, set_premium_warning] = useState(false);
    const [submitting, set_submitting] = useState(false);
    const has_foot = !premium_warning && ['cc', 'other',
        'applepay'].indexOf(view_method)>-1;
    useEffect(()=>{
        if (!props.limited_height)
            return;
        const top = content_ref.current as any;
        if (!top)
            return;
        const first_child = top.children[0];
        if (!first_child)
            return;
        set_has_scroll(top.offsetHeight - 8 < first_child.offsetHeight);
    }, [view_method, width, height, props.visible, refresh]);
    const special_plan_label = (plan: i_plan_extended)=>{
        const {renewal_price, every, free_period} = plan;
        return free_period || renewal_price
            ? <p className={cn(styles.special_plan, theme.p2, theme.primary)}>
                {renewal_price
                    ? <Fragment>For the first {every}<sup>*</sup></Fragment>
                    : `+ ${get_per(free_period, true)} free`}
            </p> : null;
    };
    return <div className={cn(styles.root, props.cls,
      props.limited_height && styles.limited_height)}
      style={props.limited_height ?
        {maxHeight: `${props.limited_height}px`} : {}}
      ref={root_ref}
      onClick={props.on_click}>
      <div className={cn(styles.header)}>
        <div className={styles.plan_selector}>
          {props.opt.plan && <Plans_select plan={props.opt.plan}
            currency={props.opt.currency}
            plans={props.opt.plans} on_change={_plan=>{
              props.opt.set_plan(_plan);
            }}/>}
        </div>
        {props.opt.currencies.length>1 &&
          <Currency_select currency={props.opt.currency}
            on_change={props.opt.set_currency}
            currencies={props.opt.currencies}
            cls={styles.currency_in_header}/>}
      </div>
      <div className={cn(styles.content,
        props.limited_height && styles.content_limited_height,
        has_foot && styles.with_foot,
        has_scroll && styles.has_scroll)} ref={content_ref}>
        {props.opt.plan && special_plan_label(props.opt.plan)}
        {props.opt.plan && <plus_ui.Step_payment expand="cc"
          with_trial={props?.with_trial}
          selected_plan={props.opt.plan}
          slide_active
          no_header
          payment_tabs_margin_v2
          input_small
          legal_tiny_size
          hidden_checkout
          email_in_cc
          legal_before_btn
          on_method_tab_change={(method, prov)=>{
            set_view_method(method);
            props.opt.set_provider(prov);
          }}
          on_toggle_premium_warning={v=>set_premium_warning(v)}
          no_currency_selector
          set_method_chosen={set_method_chosen}
          on_change_view={()=>set_refresh(refresh+1)}
          before_payment={()=>{
            console.log('before');
            set_submitting(true);
          }}
          after_payment={()=>set_submitting(false)}
          method_chosen={method_chosen} {...props.opt}/>}
          {has_foot && <div className={cn(styles.foot,
          has_scroll && styles.has_shadow)}>
          <Button caption={<>{submitting && <><Spinner width={20}/>{'\u00A0'}</>}
            Buy</>} arrow size={'sm'} disabled={submitting}
            width={120} on_click={()=>{
              // @ts-ignore
              const el = root_ref.current
                .querySelector('.step-payment-item:not(.hidden) button');
              if (el)
                el.click();
            }}/>
        </div>}
      </div>
    </div>;
};
